<template>
  <div>
    <template>
      <!-- First Row -->
      <b-row>
        <b-col lg="5">
          <user-view-user-info-card :user-data="newItem" />
        </b-col>

        <b-col lg="9" class="px-xl-2 mx-auto" v-if="!$route.params.id">
          <b-card>
            <!-- form -->
            <validation-observer ref="registerForm" #default="{ invalid }">
              <b-form
                class="auth-register-form mt-2"
                @submit.prevent="register"
              >
                <b-row>
                  <b-col md="6">
                    <!-- .first_name -->
                    <b-form-group
                      id="input-group-27"
                      :label="$t('students.first_name')"
                      label-for="input-27"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="first_name"
                        vid="first_name"
                        rules="required"
                      >
                        <b-form-input
                          id="input-27"
                          v-model="newItem.first_name"
                          type="text"
                          :placeholder="$t('students.first_name')"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <!-- .last_name -->
                    <b-form-group
                      id="input-group-28"
                      :label="$t('students.last_name')"
                      label-for="input-28"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="last_name"
                        vid="last_name"
                        rules="required"
                      >
                        <b-form-input
                          id="input-28"
                          v-model="newItem.last_name"
                          type="text"
                          :placeholder="$t('students.last_name')"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <!-- .first_name -->
                    <b-form-group
                      id="input-group-27"
                      :label="$t('students.first_name_en')"
                      label-for="input-27"
                    >
                      <b-form-input
                        id="input-27"
                        v-model="newItem.first_name_en"
                        type="text"
                        :placeholder="$t('students.first_name_en')"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <!-- .last_name -->
                    <b-form-group
                      id="input-group-28"
                      :label="$t('students.last_name_en')"
                      label-for="input-28"
                    >
                      <b-form-input
                        id="input-28"
                        v-model="newItem.last_name_en"
                        type="text"
                        :placeholder="$t('students.last_name_en')"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <!-- .email -->
                    <b-form-group
                      id="input-group-2"
                      :label="$t('users.email')"
                      label-for="input-2"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        vid="email"
                        rules="required|email"
                      >
                        <b-form-input
                          id="input-2"
                          v-model="newItem.email"
                          type="text"
                          :placeholder="$t('users.email')"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- .active_status -->

                  <b-col md="6">
                    <!-- .mobile -->
                    <b-form-group
                      id="input-group-13"
                      :label="$t('students.mobile')"
                      label-for="input-13"
                    >
                      <b-form-input
                        id="input-13"
                        v-model="newItem.mobile"
                        type="number"
                        :placeholder="$t('students.mobile')"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <!-- .nationality -->
                    <b-form-group
                      id="input-group-29"
                      :label="$t('master.nationalities')"
                      label-for="input-29"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="nationality"
                        vid="nationality"
                        rules="required"
                      >
                        <v-select
                          dir="rtl"
                          id="input-30"
                          v-model="newItem.nationality_id"
                          :options="citizenship"
                          :reduce="(country) => country.Code"
                          label="NameAr"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <!-- .country -->

                    <b-form-group
                      id="input-group-30"
                      :label="$t('countries.country')"
                      label-for="input-30"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="country"
                        vid="country"
                        rules="required"
                      >
                        <v-select
                          dir="rtl"
                          id="input-30"
                          v-model="newItem.country_id"
                          :reduce="(country) => country.Code"
                          label="NameAr"
                          :options="citizenship"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <!-- .birth_date -->
                    <b-form-group
                      id="input-group-33"
                      :label="$t('students.birth_date')"
                      label-for="input-33"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="country"
                        vid="country"
                        rules="required"
                      >
                        <b-form-datepicker
                          id="example-datepicker"
                          v-model="newItem.birth_date"
                          class="mb-1"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <!-- .gander -->
                    <b-form-group
                      id="input-group-42"
                      :label="$t('students.gander')"
                      label-for="input-42"
                    >
                      <b-form-radio
                        v-model="newItem.gender"
                        name="some-radios"
                        value="male"
                      >
                        {{ $t("site.male") }}
                      </b-form-radio>
                      <b-form-radio
                        v-model="newItem.gender"
                        name="some-radios"
                        value="female"
                      >
                        {{ $t("site.female") }}
                      </b-form-radio>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="type == 0">
                  <b-col md="4">
                    <b-form-checkbox
                      name="check-button"
                      v-if="newItem.id"
                      v-model="changePassword"
                      value="1"
                      switch
                      inline
                    >
                      {{ $t("users.change_password") }}
                    </b-form-checkbox></b-col
                  >
                  <b-col md="4" v-if="changePassword == 1">
                    <!-- .email -->
                    <b-form-group
                      :label="$t('users.password')"
                      label-for="reset-password-new"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('users.password')"
                        vid="Password"
                        rules="required|password"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                        >
                          <b-form-input
                            id="reset-password-new"
                            v-model="newItem.password"
                            :type="password1FieldType"
                            :state="errors.length > 0 ? false : null"
                            class="form-control-merge"
                            name="reset-password-new"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              class="cursor-pointer"
                              :icon="password1ToggleIcon"
                              @click="togglePassword1Visibility"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="4" v-if="changePassword == 1">
                    <!-- .email -->
                    <b-form-group
                      label-for="reset-password-confirm"
                      :label="$t('users.password_confirmation')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('users.password_confirmation')"
                        rules="required|confirmed:Password"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                        >
                          <b-form-input
                            id="reset-password-confirm"
                            v-model="newItem.password_confirmation"
                            :type="password2FieldType"
                            class="form-control-merge"
                            :state="errors.length > 0 ? false : null"
                            name="reset-password-confirm"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              class="cursor-pointer"
                              :icon="password2ToggleIcon"
                              @click="togglePassword2Visibility"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-button
                  v-if="type == 0"
                  variant="primary"
                  block
                  type="submit"
                  :disabled="invalid"
                >
                  {{ $t("site.save") }}
                </b-button>
              </b-form>
            </validation-observer>
            <hr v-if="type == 0" />
            <b-button
              v-if="type == 0"
              block
              variant="outline-danger"
              :to="{ name: 'deleteAccount' }"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
              مسح الحساب
            </b-button>
          </b-card>
        </b-col>
        <b-col
          lg="3"
          class="px-xl-2 mx-auto"
          v-if="
            $route.params.id && ($role == 'teacher' || $role == 'super_admin')
          "
        >
          <vue-apex-charts
            type="donut"
            height="350"
            :options="donutChart.chartOptions"
            :series="donutChart.series != [] ? donutChart.series : [0, 0]"
          />
        </b-col>
      </b-row>
      <b-row style="margin-top=20px">
        <b-col
          md="12"
          v-if="
            newItem != {} &&
              type == 1 &&
              ($role == 'super_admin' || $role == 'teacher')
          "
        >
          <b-card>
            <b-table
              :stacked="$mobile == 1"
              responsive
              ref="table"
              class="vuetable"
              sort-by="id"
              :fields="bootstrapTable.fields"
              :items="newItem.quran_programstudent"
              style="min-height: 250px;"
            >
              <template #cell(id)="item">
                <h4>
                  <b-badge variant="light-info">
                    {{  item["item"]["quran_program_id"] }}
                  </b-badge>
                </h4>
              </template>
              <template #cell(type_name)="item">
                <h5>
                  <b-badge variant="light-info">
                    {{  item["item"]["reading_type"] == 1 ? "رواية حفص" : "رواية ورش" }}

                  </b-badge>
                </h5>
              </template>
              <template #cell(rate)="item">
                <b-progress
                  :value="AdjustRatePercentage(item['item'])"
                  :max="AdjustMaxRatePercentage(item['item'])"
                  variant="success"
                  striped
                />
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { BRow, BCol, BAlert, BLink } from "bootstrap-vue";
import UserViewUserInfoCard from "./UserViewUserInfoCard.vue";
import UserViewUserPlanCard from "./UserViewUserPlanCard.vue";
import UserViewUserTimelineCard from "./UserViewUserTimelineCard.vue";
import UserViewUserPermissionsCard from "./UserViewUserPermissionsCard.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required, email } from "@validations";
import vSelect from "vue-select";
import Auth from "@/Apis/Auth";
import UsersController from "@/Controllers/UsersController";
import Swal from "sweetalert2";
import MediuEduController from "@/Controllers/MediuEduController";
import VueApexCharts from "vue-apexcharts";

let usersController = new UsersController();
export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    UserViewUserInfoCard,
    UserViewUserPlanCard,
    UserViewUserTimelineCard,
    UserViewUserPermissionsCard,
    // validations
    ValidationProvider,
    ValidationObserver,
    vSelect,
    VueApexCharts,
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  computed: {
    
  },
  data() {
    return {
      totalQuarters : 0,
      completed : 0,
      currentPage: 1,
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "id",
            label: "المقرأة",
            sortable: false,
          },
          {
            key: "type_name",
            label: "الرواية",
            sortable: false,
          },
          {
            key: "rate",
            label: "أنجاز",
            sortable: false,
          },
        ],
      },
      newItem: {},
      countryOptions: [],
      nationalityOptions: [],
      citizenship: [],
      password1FieldType: "password",
      password2FieldType: "password",
      // validation
      required,
      changePassword: 0,
      email,
      type: 0,
      donutChart: {
        series: [0,0],
        chartOptions: {
          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: ["#28c76f", "#ea5455"],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`;
                    },
                  },
                  // total: {
                  //   show: true,
                  //   fontSize: "1.5rem",
                  //   label: this.$i18n.t("attendance.attend"),
                  //   formatter() {

                  //     return `${this.att }  %`;
                  //   },
                  // },
                },
              },
            },
          },
          labels: ["مكتمل", "غير مكتمل"],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
    };
  },

  async created() {
    this.$mobileTitle.label = this.$i18n.t("users.account");
    const ct = new MediuEduController();

    this.citizenship = await ct.GetCitizenship();
    if (this.$route.params.id) {
      let user = await usersController.Show(this.$route.params.id);
      this.newItem = user;
      this.type = 1;
    } else {
      this.newItem = Auth.USER;
      this.type = 0;
    }

    //quranScheduleDate Adjust
    // Loop through quran_programstudent and get the quran_program_id
    for(let i in this.newItem.quran_programstudent){
      let program_id = this.newItem.quran_programstudent[i].quran_program_id;
      let saveType = this.newItem.quran_programstudent[i].quran_program.SaveType;
      let period = this.newItem.quran_programstudent[i].quran_program.period;
      //calculate the number of total quarters
      if(saveType == "asc"){
        this.totalQuarters += (30 - period + 1) * 8;
      }else if(saveType == "desc"){
        this.totalQuarters += period * 8;
      }
      //check how many quarters are completed
      let completed = this.newItem.quran_program_schedules_dates.filter((x) => {
        return x.quran_program_id == program_id && x.complete == 1;
      });
      this.completed += completed.length;
      
    }
        // donut chart series
      setTimeout(() => {
        this.donutChart.series = [this.completed, this.totalQuarters - this.completed];
      }, 1000);

  },
  methods: {
    AdjustRatePercentage(item) {
      //get the item data from this.newItem using item.quran_program_id
      // let done = 0;
      // // for(let i in item.quran_schedule_date){
      // //   if(item.quran_schedule_date[i].complete == 1){
      // //     done++;
      // //   }
      // // }
      // let rate = this.newItem.quran_program_schedules_dates.filter((x) => {
      //   return x.quran_program_id == item.quran_program_id && x.complete == 1;
      // });
      // done = rate.length;
      // return done;
      let program_id = item.quran_program_id;
      
      let completed = this.newItem.quran_program_schedules_dates.filter((x) => {
        return x.quran_program_id == program_id && x.complete == 1;
      });
      let done = completed.length;
      
      return done
    },
    AdjustMaxRatePercentage(item) {
      let saveType = item.quran_program.SaveType;
      let period = item.quran_program.period;
      if(saveType == "asc"){
        return (30 - period + 1) * 8;
      }else if(saveType == "desc"){
        return period * 8;
      }
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    register() {
      this.$refs.registerForm.validate().then(async (success) => {
        if (success) {
          let res = await usersController.Updata(this.newItem);
          if (res) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
            data = {};
            return true;
          } else {
            Swal.fire({
              position: "top-start",
              icon: "error",
              title: "Oops...",
              text: res.message,
              showConfirmButton: false,
              timer: 3000,
            });
            return false;
          }
          // if(res.)
        }
      });
    },
  },
};
</script>

<style></style>
